(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets-nav-clean"] && !Shopify.designMode) return;
  try {
    // Optimistic active-state update and optional AJAX navigation via FacetFiltersForm
  document.addEventListener('click', function(event) {
    var link = event.target.closest && event.target.closest('.facets__link');
    if (!link) return;
    var nav = link.closest && link.closest('.facets-nav[data-single-select]');
    if (!nav) return;

    // Update active states
    nav.querySelectorAll('.facets__link.active').forEach(function(el){ el.classList.remove('active'); });
    link.classList.add('active');

    var href = link.getAttribute('href') || '';
    if (!href) return;
    var qsIndex = href.indexOf('?');
    var qs = qsIndex === -1 ? '' : href.slice(qsIndex + 1);
    if (window.FacetFiltersForm && typeof FacetFiltersForm.renderPage === 'function') {
      event.preventDefault();
      FacetFiltersForm.renderPage(qs, event, true);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
